import React from "react";
import {HelmetProvider} from "react-helmet-async";
import {IntlProvider} from "react-intl";
import {BrowserRouter, Route} from "react-router-dom";
import {QueryParamProvider} from "use-query-params";
import {isMobileApp} from "@common/utils/app/appUtils"

function AppContextProvider({children}) {
    return (
        <BrowserRouter basename={isMobileApp() ? process.env.ADIC_MAPP_BASE_PATH : process.env.ADIC_MOBILE_BASE_PATH}>
            <QueryParamProvider ReactRouterRoute={Route}>
                <HelmetProvider>
                    <IntlProvider locale="ko" defaultLocale="ko">
                        {children}
                    </IntlProvider>
                </HelmetProvider>
            </QueryParamProvider>
        </BrowserRouter>
    );
}

export default AppContextProvider;
